import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('a-col', {
    staticClass: "pt-30",
    attrs: {
      "span": 12,
      "offset": 6
    }
  }, [_c('add-subject-form', _vm._g({
    ref: "addSubjectFormRef",
    attrs: {
      "data": _vm.data,
      "isLimitArea": ""
    }
  }, _vm.$listeners), [_c('a-form-model-item', {
    attrs: {
      "slot": "footer",
      "label": "",
      "wrapper-col": {
        span: 14,
        offset: 6
      }
    },
    slot: "footer"
  }, [_c('a-button', {
    attrs: {
      "size": "large",
      "data-permission": "welcome_add_subject_return",
      "id": "welcome_add_subject_return",
      "fbu-analyse-name": $t("\u8FD4\u56DE")
    },
    on: {
      "click": _vm.handleReturn
    }
  }, [_vm._v(_vm._s(_vm.t('返回')))]), _c('a-button', {
    staticClass: "ml-10",
    attrs: {
      "type": "primary",
      "data-permission": "welcome_add_subject_next",
      "id": "welcome_add_subject_next",
      "size": "large",
      "fbu-analyse-name": $t("\u4E0B\u4E00\u6B65")
    },
    on: {
      "click": _vm.handleNext
    }
  }, [_vm._v(_vm._s(_vm.t('下一步')))])], 1)], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };